function initRelatedProductSwiper(swiperEl) {
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  if (typeof Swiper === 'undefined') {
    console.error('❌ Swiper not loaded');
    return;
  }

  new Swiper(swiperEl, {
    slidesPerView: 1.5,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: { 
        slidesPerView: 2.5,
        spaceBetween: 20 
      },
      1024: { 
        slidesPerView: 3.1 
      },
      1200: { 
        slidesPerView: 4.1 
      },
    }
  });
}

const observer = new MutationObserver(() => {
  document.querySelectorAll('.rel_card_slider_swiper').forEach(initRelatedProductSwiper);
}); 

observer.observe(document.body, {
  childList: true,
  subtree: true
});